import { useIntl } from "react-intl";

const Sandbox = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraSoftwarePricingPageTemplate.features.Sandbox.header",
            defaultMessage: "Sandbox"
        }),
        content1: intl.formatMessage({
            id: "JiraSoftwarePricingPageTemplate.features.Sandbox.content1",
            defaultMessage:
                "Prepare, test, and experiment with products and apps before making changes to your production environment."
        }),
        content2: intl.formatMessage({
            id: "JiraSoftwarePricingPageTemplate.features.Sandbox.content2",
            defaultMessage:
                "The sandbox gives you a realistic understanding of what your new feature might look like or how it works when released for your users."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content1}</p>
            <p>{messages.content2}</p>
        </>
    );
};

export default Sandbox;
